export const styles = {
  text: { typography: { xs: '16_20_500' } },
};
